import { Controller } from "@hotwired/stimulus"

// New-UI composer tabs: Public reply / Internal note. Selecting "Internal note" enables
// the hidden commentpriv flag so the post is created private (matching the classic
// "Private Comment" submit). Attach to the form.
export default class extends Controller {
  static targets = ["publicTab", "privateTab", "privateFlag", "closeButton"]

  connect() { this.select(false) }

  showPublic(event) { event.preventDefault(); this.select(false) }
  showPrivate(event) { event.preventDefault(); this.select(true) }

  select(priv) {
    if (this.hasPrivateFlagTarget) this.privateFlagTarget.disabled = !priv
    if (this.hasPublicTabTarget) this.style(this.publicTabTarget, !priv)
    if (this.hasPrivateTabTarget) this.style(this.privateTabTarget, priv)
    // private + close are mutually exclusive (classic disables its Private button when
    // Close is checked) — hide "Reply & resolve" on the Internal-note tab
    if (this.hasCloseButtonTarget) this.closeButtonTarget.classList.toggle("hidden", priv)
  }

  style(el, active) {
    el.classList.toggle("text-ink-800", active)
    el.classList.toggle("font-semibold", active)
    el.classList.toggle("border-teal", active)
    el.classList.toggle("text-slate-500", !active)
    el.classList.toggle("font-medium", !active)
    el.classList.toggle("border-transparent", !active)
  }
}
